import { render, staticRenderFns } from "./widgetContents.vue?vue&type=template&id=98a5fd9e&scoped=true"
import script from "./widgetContents.vue?vue&type=script&lang=js"
export * from "./widgetContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a5fd9e",
  null
  
)

export default component.exports